import React from "react";

import classNames from "classnames";
import Label from "./Label";
import PropTypes from "prop-types";

const ProgressBar = ({
  className,
  label,
  value = "50",
  max = "100",
  showLimits = false,
  ...otherProps
}) => {
  const dataCy = otherProps["data-cy"] ?? "progress-bar";

  return (
    <>
      {label && (
        <Label
          data-cy={`${dataCy}-title`}
          className="text-sm font-semibold"
          data-testid="cs-ui-progress-bar-title"
        >
          {label}
        </Label>
      )}
      <div className={classNames("cs-ui-progress-bar__wrapper", className)}>
        <progress
          value={value}
          max={max}
          data-cy={dataCy}
          data-testid="cs-ui-progress-bar"
          {...otherProps}
          className="w-full"
        />
      </div>
      {showLimits && (
        <div className="flex justify-between -mt-2">
          <Label className="text-sm">0</Label>
          <Label className="text-sm">{max}</Label>
        </div>
      )}
    </>
  );
};

ProgressBar.propTypes = {
  /**
   * To specify external classNames that can be provided as overrides to the main wrapper.
   */
  className: PropTypes.string,
  /**
   * To specify the text to be displayed above the progress bar.
   */
  label: PropTypes.string,
  /**
   * To specify the value of the progress bar.
   */
  value: PropTypes.string,
  /**
   * To specify the maximum value of the progress bar.
   */
  max: PropTypes.string,
  /**
   * To specify whether the progress bar should show the limits or not.
   */
  showLimits: PropTypes.bool,
};

export default ProgressBar;
